import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { HeaderButton, Toolbar } from '../../../ui/molecules/Layout'
import { Linking, Text } from 'react-native'
import { routes } from '../../../../../models'
import Loading from '../../Loading'
import { BackHeader, DownloadIcon } from '../../../assets/icons'
import { GetIcon } from '../../../ui/atoms/GetIcon'
import { isWeb } from '../../../utils/helpers/commonUtils'
import DocViewer, {
  PDFRenderer,
  JPGRenderer,
  MSDocRenderer,
  PNGRenderer,
} from 'react-doc-viewer'
import { useRoute } from '@react-navigation/native'
import { useTranslation } from 'react-i18next'
import AsyncStorage from '@react-native-community/async-storage'
import { useResponsive } from '@linqpal/components/src/hooks'
import { paths } from '../../links'

const getFileExtension = (filename: string): string => {
  return filename.split('.').reverse()[0]
}

export const InvoicePreview = ({ navigation }) => {
  const route: any = useRoute()
  const { t } = useTranslation('global')
  const { id } = route.params
  const [invoice, setInvoice] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const [docUrl, setUrl] = useState('')
  const { mobileWidth } = useResponsive()
  const getInvoiceDocument = useCallback(async () => {
    if (id.length) {
      setLoading(true)
      routes.invoices
        .show(id)
        .then((resp) => {
          if (resp.invoices) {
            setInvoice(resp.invoices[0])
          }
        })
        .catch((err) => {
          console.log(err.message)
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      const doc = (await AsyncStorage.getItem('invoice_document')) || ''
      const invoice_document = await JSON.parse(doc)
      setInvoice({ invoice_document })
    }
  }, [id])

  const onDownload = () => {
    if (isWeb) {
      window.open(docUrl, '_blank')
    } else {
      Linking.openURL(docUrl)
    }
  }

  const onBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack()
    } else {
      navigation.replace(paths.Console._self, {
        screen: paths.Console.Credit._self,
      })
    }
  }

  useEffect(() => {
    getInvoiceDocument()
  }, [getInvoiceDocument])

  useEffect(() => {
    if (invoice?.invoice_document) {
      routes.file
        .download(
          id.length ? invoice.invoice_document : invoice.invoice_document.key,
        )
        .then(({ url }) => setUrl(url))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoice])

  const image = useMemo(() => {
    if (!invoice?.invoice_document) {
      return null
    }

    console.log(invoice)

    const invoiceFileExtension = getFileExtension(
      invoice.document_name || invoice.invoice_document,
    )

    if (!docUrl) {
      return null
    }

    return (
      <DocViewer
        documents={[{ uri: docUrl, fileType: invoiceFileExtension }]}
        style={{ height: '100%', width: '100%', backgroundColor: 'white' }}
        pluginRenderers={[JPGRenderer, PNGRenderer, MSDocRenderer, PDFRenderer]}
        config={{
          header: { disableHeader: false, disableFileName: true },
        }}
      />
    )
  }, [invoice, docUrl])

  if (!invoice || loading) {
    return <Loading />
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Toolbar
        centerComponent={
          <Text style={{ fontSize: 16, fontWeight: '500' }}>
            {t('previewInvoice')}
          </Text>
        }
        leftComponent={
          <HeaderButton
            icon={
              <GetIcon
                icon={<BackHeader height="20" width="20" />}
                onPress={onBack}
              />
            }
          />
        }
        rightComponent={
          <GetIcon
            icon={<DownloadIcon height="20" width="20" />}
            onPress={onDownload}
          />
        }
        headerStyle={{ width: mobileWidth }}
      />
      {image}
    </div>
  )
}
